import { render, staticRenderFns } from "./AiCheckItemManage.vue?vue&type=template&id=d4b52d3a&scoped=true&"
import script from "./AiCheckItemManage.vue?vue&type=script&lang=js&"
export * from "./AiCheckItemManage.vue?vue&type=script&lang=js&"
import style0 from "./AiCheckItemManage.vue?vue&type=style&index=0&id=d4b52d3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b52d3a",
  null
  
)

export default component.exports